/**
 * Seed Cube — ATC bulk-add splitter.
 * Load in <head> immediately AFTER sc-cart-queue.js (before theme.js).
 *
 * WHY: Shopify's native `product_added_to_cart` web-pixel event (which feeds GA4,
 * Meta, Google, TikTok and Shopify admin Analytics) only fires for the SINGLE-item
 * form of /cart/add.js ({ id, quantity }). It does NOT fire for the bulk array form
 * ({ items: [...] }). The PDP configurator (sc-product-configurator.js) and the
 * bundle builder (sc-bundle-builder.js) both post the bulk form, so their adds were
 * invisible to every ad pixel and to Shopify Analytics while still landing in the
 * custom Klaviyo diff metric (XHJgah).
 *
 * FIX: wrap the queue's public entry point (window.SC_cartFetch). When a genuine
 * user add posts a bulk { items:[...] } body, replay it as sequential single
 * { id, quantity, properties } adds through the SAME queue + leaf path, so Shopify
 * emits one native product_added_to_cart per line. Single-item wraps are unwrapped.
 * Everything else (change/update, system/gift adds, __SC_LEAF__ re-entry) passes
 * through untouched.
 */
(function () {
  if (window.__SC_ATC_BULK_SPLIT__) return;
  window.__SC_ATC_BULK_SPLIT__ = true;

  function ready(cb, tries) {
    tries = tries || 0;
    if (typeof window.SC_cartFetch === 'function') { cb(); return; }
    if (tries > 200) return; // ~6s max, then give up quietly
    setTimeout(function () { ready(cb, tries + 1); }, 30);
  }

  function normalizeUrl(input) {
    var u = typeof input === 'string' ? input : (input && input.url) || '';
    if (u.indexOf('http') === 0) {
      try { var p = new URL(u, window.location.origin); u = p.pathname + p.search; } catch (e) {}
    }
    return u;
  }

  function methodOf(input, init) {
    if (init && init.method) return String(init.method).toUpperCase();
    if (input && input.method) return String(input.method).toUpperCase();
    return 'GET';
  }

  function shallow(obj) {
    var out = {};
    if (obj) {
      for (var k in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, k)) out[k] = obj[k];
      }
    }
    return out;
  }

  ready(function () {
    var original = window.SC_cartFetch;

    function addOne(input, init, item) {
      var oneInit = shallow(init);
      oneInit.method = 'POST';
      oneInit.body = JSON.stringify(item);
      return original(input, oneInit);
    }

    function splitAdd(input, init, items) {
      var lastResponse = null;
      return items.reduce(function (chain, item) {
        return chain.then(function () {
          return addOne(input, init, item).then(function (resp) {
            lastResponse = resp;
            return resp;
          });
        });
      }, Promise.resolve()).then(function () {
        if (lastResponse) return lastResponse;
        var cartUrl = (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart.js';
        return (window.__SC_NATIVE_FETCH__ || window.fetch)(cartUrl + (cartUrl.indexOf('?') === -1 ? '?' : '&') + 't=' + Date.now(), {
          credentials: 'same-origin',
          method: 'GET'
        });
      });
    }

    window.SC_cartFetch = function (input, init) {
      try {
        if (init && init.__SC_LEAF__) return original(input, init);

        var url = normalizeUrl(input);
        var isUserAdd = methodOf(input, init) === 'POST' &&
          /\/cart\/add\.js/.test(url) &&
          init && typeof init.body === 'string' &&
          !(init.SC_ORIGIN === 'system');

        if (isUserAdd) {
          var parsed = null;
          try { parsed = JSON.parse(init.body); } catch (e) { parsed = null; }
          if (parsed && Array.isArray(parsed.items) && parsed.items.length) {
            if (parsed.items.length === 1) {
              var oneInit = shallow(init);
              oneInit.body = JSON.stringify(parsed.items[0]);
              return original(input, oneInit);
            }
            return splitAdd(input, init, parsed.items);
          }
        }
      } catch (e) {
      }
      return original(input, init);
    };
  });
})();
